<template>
  <div class="v-wrap">
    <div class="v-content">
      <div v-for="(item,index) in data" :key="index" class="box">
        <div class="title">版本号：{{item.version}}</div>
        <div class="time">更新时间：{{item.date}}</div>
        <div style="margin-left:20px">更新详情：</div>
        <div style="padding-left: 60px;" v-html="item.remark"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  },
  created() {
    this.data = window.version;
  }
};
</script>

<style lang="scss" scoped>
.v-wrap {
  width: 100%;
  height: 100%;
  background: #d5dbdd;
  color: #000;
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
.v-content {
  width: 800px;
  margin: 0px auto;
}
.box {
  padding-bottom: 10px;
  // border-bottom: 1px solid #888;
  margin-bottom: 20px;
  background: #fff;
}
.title {
  padding: 8px;
  font-size: 20px;
  font-weight: bold;
  background: #f1f3f5;
}
.time {
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0 10px;
  color: #24a6f1;
  border-bottom: 1px solid #f0f3f4;
}
</style>